<template>
  <div id="dlaczego">
    <div v-for="(item, index) in items" :key="index" class="row section-whitespace blocks-section">
      <div class="small-12 medium-6 columns blocks-section__image">
        <img :src="item._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url" :alt="item.title.rendered">
      </div>
      <div class="small-10 small-offset-2 medium-offset-1 medium-5 columns blocks-section__desc">
        <div>
          <h2>{{ item.title.rendered }}</h2>
          <div v-html="item.content.rendered"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      items: []
    }
  },
  beforeCreate: function () {
    this.$http.get(`wp/v2/why?per_page=100&_embed`).then(response => {
      for (let post in response.data) {
        this.items.push(response.data[post])
      }
    }, error => { console.log(error) })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Why.vue